// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31t5f","content":"styles_content__3-T0s"};